import { render, staticRenderFns } from "./EditViajes.vue?vue&type=template&id=57355345"
import script from "./EditViajes.vue?vue&type=script&lang=js"
export * from "./EditViajes.vue?vue&type=script&lang=js"
import style0 from "./EditViajes.vue?vue&type=style&index=0&id=57355345&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports